
import { clsx } from '../functions'
import { ReactNode, useContext } from 'react';
import './pdf-link.css'
import { useStore } from "../state/state.ts";
import { GEBAEUDE_TYP_OPTIONS, MASSNAHMEN_DACH_OPTIONS_CURRENT_LABELS, MASSNAHMEN_DACH_OPTIONS_NEW_LABELS, MASSNAHMEN_FASSADE_OPTIONS_CURRENT_LABELS, MASSNAHMEN_FASSADE_OPTIONS_NEW_LABELS, MASSNAHMEN_FENSTER_OPTIONS_CURRENT_LABELS, MASSNAHMEN_FENSTER_OPTIONS_NEW_LABELS, MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT_LABELS, MASSNAHMEN_HEIZUNG_OPTIONS_NEW_LABELS, MASSNAHMEN_KELLER_OPTIONS_CURRENT_LABELS, MASSNAHMEN_KELLER_OPTIONS_NEW_LABELS, MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT_LABELS, MASSNAHMEN_LUEFTUNG_OPTIONS_NEW_LABELS, MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT_LABELS, MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW_LABELS, MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT_LABELS, MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW_LABELS } from "../state/types.ts";
import React from "react";
import { ConfigContext } from '../config_context.ts';

export function PdfLink(){
      const context = useContext(ConfigContext);
      const client_name = context.client_name;
      const client_display_name = context.client_display_name;
      const logo_url = context.logo_url;
      const contact_url = context.contact_url;
      const uid = context.uid;
      const get_selected_unit_label_current = useStore((state)=>state.get_selected_unit_label_current);
      const kwh_to_unit_current = useStore((state)=>state.kwh_to_unit_current);
      const unit_to_kwh_current = useStore((state)=>state.unit_to_kwh_current);
      const trade_measures = useStore((state)=>state.trade_measures);

      // Labels come from the database (trade_measures) like in input-property.tsx;
      // the constants are only used as a fallback when the api did not deliver a label.
      const measure_label = (options_key: string, options_state: string, code: unknown, fallback_labels: Record<string, string>) => {
        const option = trade_measures?.["measures"]?.[options_key]?.["options"]?.[options_state]
          ?.find((x)=> x.code == code);
        return option?.label || fallback_labels[code as string] || "-";
      };

      let data = [
        "region_name",
        "gebaeude_typ",
        "postleitzahl",
        "vollgeschosse",
        "wohneinheiten",
        "baujahr",
        "wohnflaeche",
        "heizung",
        "heizung_future",
        "heizung_datum",
        "heizung_kosten",
        "keller",
        "keller_future",
        "keller_datum",
        "keller_kosten",
        "dach",
        "dach_kosten",
        "dach_future",
        "dach_datum",
        "fenster",
        "fenster_future",
        "fenster_datum",
        "fenster_kosten",
        "fassade",
        "fassade_future",
        "fassade_datum",
        "fassade_kosten",
        "solarthermie",
        "solarthermie_future",
        "solarthermie_datum",
        "solarthermie_kosten",
        "solarthermie_kollektorflaeche",
        "solarthermie_speichergroesse",
        "solarthermie_kollektorflaeche_future",
        "solarthermie_speichergroesse_future",
        "solarthermie_roof_pitch",
        "solarthermie_orientation",
        "solarthermie_roof_pitch_future",
        "solarthermie_orientation_future",
        "solarthermie_natural_refrigerant",
        "photovoltaik",
        "photovoltaik_future",
        "photovoltaik_datum",
        "photovoltaik_kosten",
        "photovoltaik_roof_pitch",
        "photovoltaik_orientation",
        "photovoltaik_annual_yield_kWh",
        "photovoltaik_battery_storage",
        "photovoltaik_roof_pitch_future",
        "photovoltaik_orientation_future",
        "photovoltaik_battery_storage_future",
        "lueftung",
        "lueftung_future",
        "lueftung_datum",
        "lueftung_kosten",
        "annual_energy_consumption_kwh_default",
        "annual_pv_production_kwh_default",
        "annual_heating_costs_default",
        "annual_energy_consumption_kwh_adjusted",
        "annual_pv_production_kwh_adjusted",
        "annual_heating_costs_adjusted",
        "annual_energy_consumption_kwh_planned",
        "annual_pv_production_kwh_planned",
        "annual_heating_costs_planned",
        "energy_efficiency_class_default_level",
        "energy_efficiency_class_adjusted_level",
        "energy_efficiency_class_planned_level",
        "energy_efficiency_class_default",
        "energy_efficiency_class_adjusted",
        "energy_efficiency_class_planned",
        "energy_savings_percentage",
        "co2_emissions_default",
        "co2_emissions_adjusted",
        "co2_emissions_planned",
        "payback_period",
        "co2_tax_savings",
        "total_beg_subsidy",
        "annual_profit_loss",
        "savings_percentage",
        "monthly_profit_loss",
        "co2_emission_current",
        "co2_emission_planned",
        "return_on_investment",
        "savings_over_lifetime",
        "total_investment_costs",
        "monthly_possible_savings",
        "period_under_review_savings",
        "annual_savings_on_energy_costs",
        "energy_efficiency_class_current",
        "energy_efficiency_class_planned",
        "annual_energy_consumption_kwh_current",
        "annual_energy_consumption_kwh_planned",
        "total_final_costs",
        "total_planned_costs",
        "total_possible_subsidy",
        "period_unter_review",
        "kostensteigerung_energie",
    ].reduce((rec, key)=> {
        const prop = useStore((state)=>state[key]);
        rec[key] = (prop == "" || prop == undefined || prop == null) ? 0 : prop;
        return rec;
    }, {});

  const today = new Date();
  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();

  const annual_energy_consumption_selected_unit_current = unit_to_kwh_current(data.annual_energy_consumption_kwh_current);
  const annual_energy_consumption_selected_unit_planned = unit_to_kwh_current(data.annual_energy_consumption_kwh_planned);
  const selected_unit = get_selected_unit_label_current();

  data = {
    ...data,
    ...(uid ? {uid} : {}),
    ...(contact_url ? {contact_url} : {}),
    ...(logo_url ? {logo_url} : {}),
  
    "issuer" : client_display_name,
    "date": dd + '.' + mm + '.' + yyyy,
    "gebaeude_typ": GEBAEUDE_TYP_OPTIONS.find((x)=> x.value == useStore((state)=> state.gebaeude_typ))?.label ?? "Keine Auswahl",
    "heizung": measure_label("heating_system", "current_state", useStore((state)=> state.heizung), MASSNAHMEN_HEIZUNG_OPTIONS_CURRENT_LABELS),
    "heizung_future": measure_label("heating_system", "planned_state", useStore((state)=> state.heizung_future), MASSNAHMEN_HEIZUNG_OPTIONS_NEW_LABELS),
    "heizung_subsidy": useStore((state)=> state.financial_plan.heating_system.subsidy) || 0,

    "heizung_kosten": useStore((state)=> state.financial_plan.heating_system.planned_costs) || 0,

    "keller": measure_label("floor_insulation", "current_state", useStore((state)=> state.keller), MASSNAHMEN_KELLER_OPTIONS_CURRENT_LABELS),
    "keller_future": measure_label("floor_insulation", "planned_state", useStore((state)=> state.keller_future), MASSNAHMEN_KELLER_OPTIONS_NEW_LABELS),
    "keller_subsidy": useStore((state)=> state.financial_plan.floor_insulation.subsidy) || 0,

    "keller_kosten": useStore((state)=> state.financial_plan.floor_insulation.planned_costs) || 0,

    "dach": measure_label("roof_insulation", "current_state", useStore((state)=> state.dach), MASSNAHMEN_DACH_OPTIONS_CURRENT_LABELS),
    "dach_future": measure_label("roof_insulation", "planned_state", useStore((state)=> state.dach_future), MASSNAHMEN_DACH_OPTIONS_NEW_LABELS),
    "dach_subsidy": useStore((state)=> state.financial_plan.roof_insulation.subsidy) || 0,

    "dach_kosten": useStore((state)=> state.financial_plan.roof_insulation.planned_costs) || 0,

    "fenster": measure_label("window", "current_state", useStore((state)=> state.fenster), MASSNAHMEN_FENSTER_OPTIONS_CURRENT_LABELS),
    "fenster_future": measure_label("window", "planned_state", useStore((state)=> state.fenster_future), MASSNAHMEN_FENSTER_OPTIONS_NEW_LABELS),
    "fenster_subsidy":useStore((state)=> state.financial_plan.window.subsidy) || 0,

    "fenster_kosten":useStore((state)=> state.financial_plan.window.planned_costs) || 0,

    "fassade": measure_label("facade_insulation", "current_state", useStore((state)=> state.fassade), MASSNAHMEN_FASSADE_OPTIONS_CURRENT_LABELS),
    "fassade_future": measure_label("facade_insulation", "planned_state", useStore((state)=> state.fassade_future), MASSNAHMEN_FASSADE_OPTIONS_NEW_LABELS),
    "fassade_subsidy": useStore((state)=> state.financial_plan.facade_insulation.subsidy) || 0,
    "fassade_kosten": useStore((state)=> state.financial_plan.facade_insulation.planned_costs) || 0,

    "solarthermie": measure_label("solar_thermal", "current_state", useStore((state)=> state.solarthermie), MASSNAHMEN_SOLARTHERMIE_OPTIONS_CURRENT_LABELS),
    "solarthermie_future": measure_label("solar_thermal", "planned_state", useStore((state)=> state.solarthermie_future), MASSNAHMEN_SOLARTHERMIE_OPTIONS_NEW_LABELS),
    "solarthermie_subsidy": useStore((state)=> state.financial_plan.solar_thermal.subsidy) || 0,

    "solarthermie_kosten": useStore((state)=> state.financial_plan.solar_thermal.planned_costs) || 0,

    "photovoltaik": measure_label("photovoltaics", "current_state", useStore((state)=> state.photovoltaik), MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_CURRENT_LABELS),
    "photovoltaik_future": measure_label("photovoltaics", "planned_state", useStore((state)=> state.photovoltaik_future), MASSNAHMEN_PHOTOVOLTAIK_OPTIONS_NEW_LABELS),
    "photovoltaik_subsidy": useStore((state)=> state.financial_plan.photovoltaics.subsidy) || 0,

    "photovoltaik_kosten": useStore((state)=> state.financial_plan.photovoltaics.planned_costs) || 0,

    "lueftung": measure_label("ventilation_system", "current_state", useStore((state)=> state.lueftung), MASSNAHMEN_LUEFTUNG_OPTIONS_CURRENT_LABELS),
    "lueftung_future": measure_label("ventilation_system", "planned_state", useStore((state)=> state.lueftung_future), MASSNAHMEN_LUEFTUNG_OPTIONS_NEW_LABELS),
    "lueftung_subsidy": useStore((state)=> state.financial_plan.ventilation_system.subsidy) || 0,

    "lueftung_kosten": useStore((state)=> state.financial_plan.ventilation_system.planned_costs) || 0,

    "building_system_costs": useStore((state)=> state.building_system.costs) || 0,
    "building_system_subsidy": useStore((state)=> state.building_system.subsidy) || 0,
    "building_system_percentage": useStore((state)=> state.building_system.percentage) || 0,
    "building_system_max_funding": useStore((state)=> state.building_system.max_funding) || 0,
    "building_envelope_isfp": useStore((state)=> state.building_envelope.isfp) || 0,
    "building_envelope_costs": useStore((state)=> state.building_envelope.costs) || 0,
    "building_envelope_subsidy": useStore((state)=> state.building_envelope.subsidy) || 0,
    "building_envelope_percentage": useStore((state)=> state.building_envelope.percentage) || 0,
    "building_envelope_max_funding": useStore((state)=> state.building_envelope.max_funding) || 0,

    "house_image":`images/${useStore((state)=> state.gebaeude_typ)}.svg`,
    annual_energy_consumption_selected_unit_current, 
    annual_energy_consumption_selected_unit_planned, 
    selected_unit
  };

  // data = Object.keys(data).forEach((key)=>{
  //   data[key] = 
  // });

  const params = Object.keys(data).map((key)=>  key + "=" + (data[key] == "" ? 0 : encodeURIComponent(data[key]))).join("&");
  //const link = `https://pdf.esr.carbacan-dev.de?${params}`;
  const link = `https://esr-pdf.fe-bis.de/${client_name}?${params}`;

  //https://pdf.esr.carbacan-dev.de?issuer=febis&logo_file=logo.jpeg&date=25.Februar2025&gebaeude_typ=Einfamilienhaus&postleitzahl=61267&vollgeschosse=10&wohneinheiten=10&stadt=Neu-Anspach&baujahr=1987&wohnflaeche=120&heizung=Maßname&heizung_future=Maßname&heizung_datum=10&heizung_kosten=10&keller=Maßname&keller_future=Maßname&keller_datum=10&keller_kosten=10&dach=Maßname&dach_future_schraege=Maßname&dach_future_decke=Maßname&dach_datum=10&dach_kosten=10&fenster=Maßname&fenster_future=Maßname&fenster_datum=10&fenster_kosten=10&fassade=Maßname&fassade_future=Maßname&fassade_datum=10&fassade_kosten=10&solarthermie=Maßname&solarthermie_future=Maßname&solarthermie_datum=10&solarthermie_kosten=10&solarthermie_kollektorflaeche=10&solarthermie_speichergroesse=10&solarthermie_kollektorflaeche_future=10&solarthermie_speichergroesse_future=10&solarthermie_roof_pitch=10&solarthermie_orientation=10&solarthermie_roof_pitch_future=10&solarthermie_orientation_future=10&solarthermie_natural_refrigerant=10&photovoltaik=Maßname&photovoltaik_future=Maßname&photovoltaik_datum=10&photovoltaik_kosten=10&photovoltaik_roof_pitch=10&photovoltaik_orientation=10&photovoltaik_annual_yield_kWh=10&photovoltaik_battery_storage=10&photovoltaik_roof_pitch_future=10&photovoltaik_orientation_future=10&photovoltaik_battery_storage_future=10&lueftung=Maßname&lueftung_future=Maßname&lueftung_datum=10&lueftung_kosten=10&annual_energy_consumption_kwh_default=28750&annual_pv_production_kwh_default=0&annual_heating_costs_default=2875&annual_energy_consumption_kwh_adjusted=0&annual_pv_production_kwh_adjusted=0&annual_heating_costs_adjusted=0&annual_energy_consumption_kwh_planned=0&annual_pv_production_kwh_planned=0&annual_heating_costs_planned=0&energy_efficiency_class_default_level=287&energy_efficiency_class_adjusted_level=0&energy_efficiency_class_planned_level=0&energy_efficiency_class_default=H&energy_efficiency_class_adjusted=H&energy_efficiency_class_planned=H&co2_emissions_default=6929&co2_emissions_adjusted=0&co2_emissions_planned=0&payback_period=0&co2_tax_savings=0&total_beg_subsidy=0&annual_profit_loss=0&savings_percentage=0&monthly_profit_loss=0&co2_emission_current=0&co2_emission_planned=0&return_on_investment=0&savings_over_lifetime=0&total_investment_costs=0&monthly_possible_savings=0&period_under_review_savings=0&annual_savings_on_energy_costs=0&energy_efficiency_class_current=0&energy_efficiency_class_planned=0&annual_energy_consumption_kwh_current=0&annual_energy_consumption_kwh_planned=0
  return <a 
      className="pdf-link" 
      target={"_blank"} 
      href={link} 
      style={{marginLeft: "auto"}}
      role="button"
      aria-label="Bericht anzeigen"
      tabIndex={0}
    >
      Bericht anzeigen
    </a>;
}

